import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { closeThread, uncloseThread } from 'bundles/discussions/actions/ThreadSettingsActions';

import _t from 'i18n!nls/discussions';

class CloseThreadButton extends React.Component {
  static propTypes = {
    questionId: PropTypes.string,
    forumType: PropTypes.string,
    isClosed: PropTypes.bool,
    isError: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CloseThreadButton.contextTypes>;

  toggleClosed = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isClosed' does not exist on type 'Readon... Remove this comment to see the full error message
    if (!this.props.isClosed) {
      this.context.executeAction(closeThread, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
        questionId: this.props.questionId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
        forumType: this.props.forumType,
      });
    } else {
      this.context.executeAction(uncloseThread, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
        questionId: this.props.questionId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
        forumType: this.props.forumType,
      });
    }
  };

  renderErrorState() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isError' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.isError) {
      return <div className="errorMessage">{_t('Sorry, something went wrong. Try again.')}</div>;
    }

    return null;
  }

  render() {
    return (
      <button className="rc-CloseThreadButton nostyle" onClick={this.toggleClosed}>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'isClosed' does not exist on type 'Readon... Remove this comment to see the full error message */}
        {this.props.isClosed ? _t('Undo Close') : _t('Close')}
        {this.renderErrorState()}
      </button>
    );
  }
}

export default connectToStores(CloseThreadButton, ['ThreadSettingsStore'], ({ ThreadSettingsStore }) => {
  return {
    questionId: ThreadSettingsStore.getQuestionId(),
    forumType: ThreadSettingsStore.getForumType(),
    isClosed: ThreadSettingsStore.isClosed(),
    isError: ThreadSettingsStore.isError(),
  };
});
